/* eslint-disable */
import Countdown from 'countdown-js';

var ostorage = window.localStorage;
const storage = {
    // localStorage存入
    set: function (name, val) {
        ostorage.setItem(name, val);
    },
    // localStorage取出
    get: function (name) {
        return ostorage.getItem(name);
    },
    remove: function (name) {
        ostorage.removeItem(name);
    }
};
const myCookie = {
    setCookie:function(cname,cvalue,exdays){
        var d = new Date();
        d.setTime(d.getTime()+(exdays*24*60*60*1000));
        var expires = "expires="+d.toGMTString();
        document.cookie = cname + "=" + cvalue + "; " + expires;
    },
    getCookie: function(cname){
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i=0; i<ca.length; i++)
        {
            var c = ca[i].trim();
            if (c.indexOf(name)==0) return c.substring(name.length,c.length);
        }
        return "";
    }
}
window.String.prototype.trim = function() {
    return this.replace(/(^\s*)|(\s*$)/g, '');
}
function isWeiXin () {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/micromessenger/i)) {
        if (JSON.stringify(ua.match(/micromessenger/i)[0]) === '"micromessenger"') {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}
const Common = {
    // 倒计时
    getTime(nowTime, endTime, callback) {
        // 需要时间戳
        let leftTime = endTime - nowTime;
        let h, m, s, ms;
        if (leftTime >= 0) {
          h = Math.floor(leftTime / 1000 / 60 / 60);
          m = Math.floor(leftTime / 1000 / 60 % 60);
          s = Math.floor(leftTime / 1000 % 60);
          ms = Math.floor(leftTime % 1000);
          if (ms < 100) {
              ms = '0' + ms;
          }
          if (s < 10) {
              s = '0' + s;
          }
          if (m < 10) {
              m = '0' + m;
          }
          if (h < 10) {
              h = '0' + h;
          }
        } else {
            h = '00'
            m = '00'
            s = '00'
           // console.log('已截止')
        }
        // this.time.hour = h;
        // this.time.minute = m;
        // this.time.second = s;
        // setInterval(() => {
        //     console.log('s', s)

        //     callback({h, m, s})
        // }, 1000)
        callback({h, m, s}, leftTime)

    },
    setupWebViewJavascriptBridge: function (callback) {  //调用原生ios的方法(不能更改)  /*这段代码是固定的，必须要放到js中*/
        if(window.WebViewJavascriptBridge) { return callback(WebViewJavascriptBridge); }
        if(window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }
        window.WVJBCallbacks = [callback];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)
    },
    /**
     * JS调用原生
     * @param {String} functionName
     * @param {Object} params
     * @param {Function} backFunction
     */
    callNative: function (functionName, params, backFunction){
        Common.setupWebViewJavascriptBridge(function(bridge) {
            /* Initialize your app here */
            bridge.callHandler(functionName, {...params},
                function callback(response) {
                    backFunction(response)
                }
            )
        })
    },
    // 取得样式
    getStyle: function (dom, styleName) {
        if (dom.currentStyle) {
            return dom.currentStyle[styleName];
        } else {
            return window.getComputedStyle(dom, false)[styleName];
        }
    },
    // timestampToTime: function (timestamp) {
    //     const date = new Date(timestamp); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    //     const Y = date.getFullYear() + '-';
    //     const M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    //     const D = date.getDate() + ' ';
    //     const h = date.getHours() + ':';
    //     const m = date.getMinutes() + ':';
    //     const s = date.getSeconds();
    //     return Y+M+D+h+m+s;
    // },
    timestampToTime:function (value) {
    let date = new Date(value);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    let m = date.getMinutes();
    m = m < 10 ? ('0' + m) : m;
    let s = date.getSeconds();
    s = s < 10 ? ('0' + s) : s;
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    stringTojson: (data) => {
        var odata = data.split(';');
        var allDate = [];
        for (var i = 0; i < odata.length; i++) {
            var oneDate = odata[i].split('_');
            allDate.push(oneDate);
        }
        return allDate;
    },
    // 窗口的高度
    windowHeight: function () {
        if (window.innerHeight !== undefined) {
            return window.innerHeight;
        } else {
            var B = document.body;
            var D = document.documentElement;
            return Math.min(D.clientHeight, B.clientHeight);
        }
    },
    // body的高度
    bodyHeight: function () {
        return parseInt(Common.getStyle(document.getElementsByTagName('body')[0], 'height'));
    },
    // body是否占满全屏
    isFullScreen: function () {
        if (Common.bodyHeight() < Common.windowHeight()) {
            return false;
        }
        return true;
    },
    // 设置body为全屏, 不传参数默认body
    setFullScreen: function (dom) {
        // 设置元素的高度100%
        if (dom) {
            if (parseInt(Common.getStyle(dom, 'height')) < Common.windowHeight()) {
                dom.style.height = Common.windowHeight() + 'px';
            } else {
                dom.style.height = 'auto';
                if (parseInt(Common.getStyle(dom, 'height')) < Common.windowHeight()) {
                    dom.style.height = Common.windowHeight() + 'px';
                }
            }
        } else {
            // 不是全屏
            if (!Common.isFullScreen()) {
                document.getElementsByTagName('body')[0].style.height = Common.windowHeight() + 'px';
            } else {
                // 已经全屏,设置为自动
                document.getElementsByTagName('body')[0].style.height = 'auto';
                // 自动适应后不是全屏
                if (!Common.isFullScreen()) {
                    document.getElementsByTagName('body')[0].style.height = Common.windowHeight() + 'px';
                }
            }
        }
    },
    // 获取地址栏参数
    getQueryString: function (name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    },
    getUrlKey: function (name) {
        let url = location.href.replace(location.search,'');
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null
    },
    /**
     * [countdown 倒计时]
     * @param {[Object]} time [时间对象{days: '',hours: '',minutes: '',seconds: ''}]
     * @param {[Number]}  endTime [结束时间-毫秒]
     * @param {[Boolean]} isTimeout [是否过期]
     * @param {[Function]} callback [回调方法]
    */
    countdown: function (time, endTime, isTimeout, callback) {
        if (new Date().getTime() > endTime) {
            isTimeout = true;
            callback(time, isTimeout);
            return;
        } else {
            isTimeout = false;
        }
        let arr = Object.keys(time);
        let timer = Countdown.timer(endTime, (timeLeft) => {
            isTimeout = false;
            time = timeLeft;
            for (let i = 0; i < arr.length; i++) {
                if (timeLeft[arr[i]] < 10) {
                    time[arr[i]] = '0' + timeLeft[arr[i]];
                }
            }
            callback(time, isTimeout);
        }, () => {
            isTimeout = true;
            callback(time, isTimeout);
        })
    },
    // 名字省略显示
    ellipsisName: function (value) {
        if (!value) {
            return;
        }
        if (value.length === 2) {
            return value[0] + '*';
        } else if (value.length >= 3) {
            var str = value.substring(0, 1);
            for (var i = 1; i < value.length - 1; i++) {
                str += '*';
            }
            return str + value.substring(value.length - 1);
        } else {
            return '*';
        }
    },
    // 去掉前后空格
    Trim (str) {
        if (str || parseInt(str) === 0) {
            return str.replace(/(^\s*)|(\s*$)/g, '');
        } else {
            return '';
        }
    },
    // 身份证省略显示
    ellipsisId: function (value) {
        if (!value) {
            return;
        }
        var str = value.substring(0, 4);
        for (var i = 4; i < value.length - 4; i++) {
            str += '*';
        }
        return str + value.substring(value.length - 4);
    },
    // 获取当前时间的后几天和前几天 用法 GetDateStr(60), 60天后 格式1990-06-07
    GetDateStr(AddDayCount) {
        var dd = new Date();
        dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
        var y = dd.getFullYear();
        var m = dd.getMonth()+1;//获取当前月份的日期
        m = m < 10 ? ('0' + m) : m;
        var d = dd.getDate();
        d = d < 10 ? ('0' + d) : d;
        return y + '-' + m + '-' + d;
    },
    // 获取当前时间的后几天和前几天 用法 GetDateStr(60), 60天后 格式19900607
    GetDateStr1(AddDayCount) {
        var dd = new Date();
        dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
        var y = dd.getFullYear();
        var m = dd.getMonth()+1;//获取当前月份的日期
        m = m < 10 ? ('0' + m) : m;
        var d = dd.getDate();
        d = d < 10 ? ('0' + d) : d;
        return '' + y + m + d + '';
    },
    // 标准格式转换成19701101
    formatNewDate: function (date) {
        var month = parseInt(date.getMonth()) + 1;
        var day = parseInt(date.getDate());
        month = month < 10 ? ('0' + month) : month;
        day = day < 10 ? ('0' + day) : day;
        var result = '' + date.getFullYear() + month + '' + day;
        // console.log(result)
        return result;
    },
    //标准格式转换成1970-11-01
    formatNewDate1: function (val) {
        // if (val) {
        //     var date = new Date(val);
        //     var y = 1900 + date.getYear();
        //     var m = '0' + (date.getMonth() + 1);
        //     var d = '0' + date.getDate();
        //     return y + '-' + m.substring(m.length - 2, m.length) + '-' + d.substring(d.length - 2, d.length);
        //   } else {
        //     return val;
        //   }
        var date = new Date(val);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = (date.getDate() +1 < 10 ? '0'+(date.getDate()+1) : date.getDate()+1) + ' ';
        var h = ' ' + (date.getHours() +1 < 10 ? '0'+(date.getHours()+1) : date.getHours()+1) + ':';
        var m = (date.getMinutes() +1 < 10 ? '0'+(date.getMinutes()+1) : date.getMinutes()+1) + ':';
        var s = (date.getSeconds() +1 < 10 ? '0'+(date.getSeconds()+1) : date.getSeconds()+1);
        return Y+M+D+h+m+s;
    },
    openApp: function (url) {
        //实际上就是新建一个iframe的生成器
        var createIframe=(function(){
            var iframe;
            return function(){
                if(iframe){
                    return iframe;
                }else{
                    iframe = document.createElement('iframe');
                    iframe.style.display = 'none';
                    document.body.appendChild(iframe);
                    return iframe;
                }
            }
        })();
        var openIframe = createIframe();
        openIframe.url = url;
    },
    numFormat: function(value) {
        if(!value) return '';
        /*原来用的是Number(value).toFixed(0)，这样取整时有问题，例如0.51取整之后为1，感谢Nils指正*/
        var intPart =  Number(value)|0; //获取整数部分
        var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
        return intPartFormat;
    }
}
var valid = {
    /**
     * [ID 身份证验证]
     * @param {[type]} gets [description]
     */
    ID: function (gets) {
        var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]; // 加权因子;
        var ValideCode = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]; // 身份证验证位值，10代表X;
        if (gets.length === 15) {
            return isValidityBrithBy15IdCard(gets);
        } else if (gets.length === 18) {
            var aidCard = gets.split(''); // 得到身份证数组
            if (isValidityBrithBy18IdCard(gets) && isTrueValidateCodeBy18IdCard(aidCard)) {
                return true;
            }
            return false;
        }
        return false;

        function isTrueValidateCodeBy18IdCard (aidCard) {
            var sum = 0; // 声明加权求和变量
            if (aidCard[17].toLowerCase() === 'x') {
                aidCard[17] = 10; // 将最后位为x的验证码替换为10方便后续操作
            }
            for (var i = 0; i < 17; i++) {
                sum += Wi[i] * aidCard[i]; // 加权求和
            }
            var valCodePosition = sum % 11; // 得到验证码所位置
            if (parseInt(aidCard[17]) === ValideCode[valCodePosition]) {
                return true;
            }
            return false;
        }

        function isValidityBrithBy18IdCard (idCard18) {
            var year = idCard18.substring(6, 10);
            var month = idCard18.substring(10, 12);
            var day = idCard18.substring(12, 14);
            var tempdate = new Date(year, parseFloat(month) - 1, parseFloat(day));
            // 这里用getFullYear()获取年份，避免千年虫问题
            if (tempdate.getFullYear() !== parseFloat(year) || tempdate.getMonth() !== parseFloat(month) - 1 || tempdate.getDate() !== parseFloat(day)) {
                console.log('身份证生日错误')
                return false;
            }
            return true;
        }

        function isValidityBrithBy15IdCard (idCard15) {
            var year = idCard15.substring(6, 8);
            var month = idCard15.substring(8, 10);
            var day = idCard15.substring(10, 12);
            var tempdate = new Date(year, parseFloat(month) - 1, parseFloat(day));
            // 对于老身份证中的你年龄则不需考虑千年虫问题而使用getYear()方法
            if (tempdate.getYear() !== parseFloat(year) || tempdate.getMonth() !== parseFloat(month) - 1 || tempdate.getDate() !== parseFloat(day)) {
                return false;
            }
            return true;
        }
    },
    /**
     * [phone 手机验证]
     * @param  {[type]} gets [description]
     * @return {[type]}      [description]
     */
    phone: function (gets) {
        if (/^13[0-9]{9}$|14[0-9]{9}|15[0-9]{9}$|16[0-9]{9}$|17[0-9]{9}$|18[0-9]{9}$|19[0-9]{9}$/.test(gets)) {
            return true;
        } else {
            return false;
        }
    },
    /**
     * [plateNumber 车牌号验证]
     * @param  {[type]} gets [description]
     * @return {[type]}      [description]
     */
    plateNumber: function (gets) {
        var re = /^[\u4e00-\u9fa5]{1}[a-zA-Z]{1}[a-zA-Z_0-9]{5}$/; // 车牌号
        if (gets.search(re) === -1) {
            return false;
        } else {
            return true;
        }
    },
    // 车辆品牌验证
    CarBrand: function (gets) {
        var re = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/; // 品牌
        if (re.test(gets)) {
            return true;
        } else {
            return false;
        }
    },
    // 车辆品牌验证
    CarNumber: function (gets) {
        var re = /^[a-zA-Z0-9]+$/; // 品牌
        if (re.test(gets)) {
            return true;
        } else {
            return false;
        }
    },
    /**
     * [userName 姓名验证]
     * @param  {[type]} gets [description]
     * @return {[type]}      [description]
     */
    userName: function (gets) {
        /* var re = /^[\u4e00-\u9fa5]{2,20}$/;2到20个中文字符 */
        var re = /^[A-Za-z]|[\u4e00-\u9fa5]{2,20}$/;
        if (re.test(gets)) {
            return true;
        } else {
            return false;
        }
    },
    // 中文名字
    cneeName: function (gets) {
        var re = /^[\u4e00-\u9fa5]{1,10}$/;
        if (re.test(gets)) {
            return true;
        } else {
            return false;
        }
    },
    // 信息页面时间 20170909
    time: function (gets) {
        var re = /^[0-9]{8}$/; // 品牌
        if (re.test(gets)) {
            return true;
        } else {
            return false;
        }
    },
    // 昵称
    nickName: function (gets) {
        var re = /^[\u4E00-\u9FA5A-Za-z0-9_]{1,6}$/;
        if (re.test(gets)) {
            return true;
        } else {
            return false;
        }
    },
    // 其他 //中文，数字，母
    else: function (gets) {
        var re = /^[\u4E00-\u9FA5A-Za-z0-9_]{1,40}$/;
        if (re.test(gets)) {
            return true;
        } else {
            return false;
        }
    },
    // 邮政编码验证
    areaCode: function (gets) {
        var re = /[1-9]\d{5}(?!\d)/;
        if (re.test(gets)) {
            return true;
        } else {
            return false;
        }
    },
    // 密码 检测密码由6-20字母和数字组成，不能是纯数字或纯英文
    password: function (value) {
        var re = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
        if (re.test(value)) {
            return true;
        } else {
            return false;
        }
    },
    // 支付密码 6-12位数字字母组成
    PayPassword: function (gets) {
        var re = /^[\da-zA-z]{6,12}$/;
        if (re.test(gets)) {
            return true;
        } else {
            return false;
        }
    },
    contrastDate: function (a, b) {
        var arr = a.split('-');
        var startTime = new Date(arr[0], arr[1] - 1, arr[2]);
        var startTimes = startTime.getTime();
        var arrs = b.split('-');
        var endTime = new Date(arrs[0], arrs[1] - 1, arrs[2]);
        var endTimes = endTime.getTime();
        if (startTimes >= endTimes) {
            return false;
        } else {
            return true;
        }
    },
    /**
     * [邮箱验证 description]
     * @param  {[type]}  gets [description]
     * @return {Boolean}      [description]
     */
    isEmail: function (gets) {
        var reg = /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/;
        return reg.test(gets);
    },
    /**
     * [地址验证 description]
     * @param  {[type]} gets [description]
     * @return {[type]}      [description]
     */
    address: function (gets) {
        var reg = /^[A-Za-z]|[\u4e00-\u9fa5]|[0-9]{4,}$/;
        return reg.test(gets);
    },
    // 是否是微信浏览器
    isWeiXin: function () {
        return isWeiXin();
    },
    // ios设备
    isIOS: function () {
        var u = navigator.userAgent;
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        return isIOS;
    },
    // android设备
    isAndroid: function () {
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
        return isAndroid;
    }
};

function skipPage(code, type, buttonName, buttonSkipUrl,shareWXID,shareTitle,shareCount,shareImage,shareUrl,skipUrl,buttonType) {
    //1. JS调用安卓、IOS
    // {
    //     "businessType": "1",
    //     "businessBody": {
    //         "bodyType":"100",
    //         "shareTitle":"分享",(分享专用)
    //         "shareCount":"邀请好友"，(分享专用)
    //         "shareImage":"www.baidu.png"(分享专用)
    //         "shareUrl":"www.baidu.com"(分享专用)
    //         "buttonName":"金币说明"(title右侧按钮名称)
    //         "buttonSkipUrl":"www.baidu.com"(title右侧按钮跳转连接)
    //     }
    // }
    // 备注：
    // 方法名称：xdcommon.xdArgAsyn(JSON)
    // businessType:
    //     1、跳转指定页面
    //     bodyType：
    //         100：跳转登录页面
    //         101：兑换记录（金币记录）
    //         102：收货地址编辑
    //         103：金币记录
    //         104:  打开商城小程序
    //         105:  拨打客服电话
    //     shareTitle、shareCount、shareImage、shareUrl、buttonName、buttonSkipUrl（可以为空或者不存）
    //     2、工具类
    //     bodyType：
    //         200：刷新
    //         shareTitle、shareCount、shareImage、shareUrl、buttonName、buttonSkipUrl（可以为空或者不存）
    //         201：分享
    //         shareTitle、shareCount、shareImage、shareUrl（不能为空） buttonName、buttonSkipUrl（可以为空或者不存）
    //         202：关闭
    //         shareTitle、shareCount、shareImage、shareUrl、buttonName、buttonSkipUrl（可以为空或者不存）
    //      203：title右侧工具按钮设置--支持文字、图片格式
    //     buttonName（图片名称或按钮文字）:存在http时候显示图片，反之显示文字、buttonSkipUrl、buttonType:1:跳转路径 2:截屏
    //         204：新开webview
	//	       skipUrl（不能为空）buttonName、buttonSkipUrl、 shareTitle、shareCount、shareImage、shareUrl、（可以为空或者不存）
    //         buttonName、buttonSkipUrl（不能为空） shareTitle、shareCount、shareImage、shareUrl、（可以为空或者不存）
    //         205 全屏风格

    // 2.安卓、IOS调用JS
    //     方法getPlatformToken，参数JSON形式
    //             例如	{
    //                 "platformType":“android、ios”
    //                 "accessToken": "*********"
    //                 }
    let params = {
        businessType: type || 1,
        businessBody: {
          bodyType: code,
          buttonName: buttonName || '',
          buttonSkipUrl: buttonSkipUrl || '',
          shareWXID:shareWXID || '',
          shareTitle:shareTitle || '',
          shareCount:shareCount || '',
          shareImage:shareImage || '',
          shareUrl:shareUrl || '',
          skipUrl:skipUrl || '',
          buttonType:buttonType || ''
        }
    }
    console.log('params',params)
//  dsBridge.call('name',params,fn) // 不加fn，目前ios调不通
    dsBridge.call('xdcommon.xdArgAsyn',params,() => {});
};

function remindNativeRefreshJSMethod(wayCode) {
    // bodyType：
	// 	300：获取token
	// 	301：获取orderNo
	// sp:
	// {
	// 	"businessType": "3",
	// 	"businessBody": {
	// 		"bodyMethods":"300,301,302,,....",（类型3专用）
	// 	}
	// }
    let params = {
        businessType: 3,
       	businessBody: {
		 bodyMethods: wayCode
		}
    }
    dsBridge.call('xdcommon.xdArgAsyn',params,() => {});
}
export {
    valid,
    Common,
    storage,
    myCookie,
    skipPage,
    remindNativeRefreshJSMethod
}



// WEBPACK FOOTER //
// ./src/utils/common.js